/**
 * Plain object CustomsInvoice representation.
 *
 */

/**
 * Plain object DraftCustomsInvoice representation.
 *
 */

/**
 * Reasons for a customs document to be exported
 */
let CustomsReasonToExport = /*#__PURE__*/function (CustomsReasonToExport) {
  CustomsReasonToExport["PURCHASE_OR_SALE"] = "PURCHASE_OR_SALE";
  CustomsReasonToExport["PERSONAL_BELONGINGS"] = "PERSONAL_BELONGINGS";
  CustomsReasonToExport["SAMPLE"] = "SAMPLE";
  CustomsReasonToExport["DOCUMENTS"] = "DOCUMENTS";
  CustomsReasonToExport["RETURN"] = "RETURN";
  return CustomsReasonToExport;
}({});

/**
 * Representation of a signature in a Customs Invoice
 */

export { CustomsReasonToExport };
//# sourceMappingURL=CustomsInvoice.js.map
